import React from 'react';
import { Link } from 'gatsby';
import { Collapsible } from 'module-tsl-ui-collapsible';
import { Location } from '@reach/router';
import classNames from 'classnames';

import { ItemToAppear } from '../utils/pose';
import { WIP_SECTIONS } from '../state/constants';

const NavBlock = ({ navChildren, name, to, delay, pathPrefix }) => (
  <Location>
    {({ location: { pathname } }) => {
      const isCurrent = pathname
        .replace(pathPrefix, '')
        .indexOf(to) > -1;
      const cName = classNames('nav-main-item', {
        'nav-main-item--has-children': navChildren.length > 0,
        'nav-main-item--current': isCurrent,
      });
      return (
        <ItemToAppear initialPose="closed" pose="open" after={delay}>
          <Link
            to={isCurrent ? '/' : to}
            className={cName}
          >
            {name}
            {WIP_SECTIONS.includes(name) && <span className="wip-label">WIP</span>}
          </Link>
          {navChildren.length > 0 &&
          <Collapsible toggled={isCurrent}>
            <ul className="nav-ul">
              {navChildren.map(({ path: childTo, name: childName }) => {
                const pathToCheck = pathname
                  .replace(pathPrefix, '')
                  .replace(/\/usage(\/)?/, '');
                const isCurrent = (pathToCheck === `${to}${childTo}` || pathToCheck === `${to}${childTo}/`);
                return (
                  <li key={`${to}${childTo}`}>
                    <Link
                      className={isCurrent ? 'is-current' : ''}
                      to={`${to}${childTo}`}
                    >
                      {childName}
                    </Link>
                  </li>
                )
              })}
            </ul>
          </Collapsible>
          }
        </ItemToAppear>
      )
    }}
  </Location>
);

export default NavBlock;
